import React from 'react';
import { useSelector } from 'react-redux';

import Checkbox from 'dpl/form/components/Checkbox';
import { FILTER_SIZE } from 'dpl/constants/query_params';
import useSearchQueryFilter from 'dpl/breeder_search_results/hooks/useSearchQueryFilter';

import FilterDrawer from './FilterDrawer';

export default function SizeFilter() {
  const { searchQueryFilterValues, toggleFilter } =
    useSearchQueryFilter(FILTER_SIZE);

  const { breedSizes } = useSelector(({ server }) => server);

  if (breedSizes.length === 0) {
    return null;
  }
  return (
    <FilterDrawer className="BreederSearchResultsSizeFilter" title="Size">
      {breedSizes.map(({ title, value }) => (
        <div key={value} className="mb4">
          <Checkbox
            key={value}
            id={`${FILTER_SIZE}_${value}`}
            name={title}
            title={title}
            value={value}
            checked={searchQueryFilterValues.includes(Number(value))}
            onChange={e => toggleFilter(Number(e.target.value))}
          />
        </div>
      ))}
    </FilterDrawer>
  );
}
